module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Pictures1-daa8c5bd29d00efd7fab868c17cafff8.svg";